import { api } from 'app/api'
import { useCallback, useState } from 'react'
import { SalePointCategoriesParamsPost } from 'app/common/types/sale-points/categories'
import { POST_SALE_POINT_CATEGORIES, convertParams } from 'app/common/api/requests/food/schools/sale_points/categories/post'


export const useSalePointCategoriesMutate = () => {
  const [pending, setPending] = useState<boolean>(false)

  const submit = useCallback(async (params: SalePointCategoriesParamsPost) => {
    setPending(true)

    const res = await api.request(POST_SALE_POINT_CATEGORIES, {
      error: 'Не удалось обновить список категорий для точки продаж',
      params,
      convertions: {
        convertParams,
      },
    })
    if (res) {
      setPending(false)
      return true
    }
    setPending(false)
    return false
  }, [])


  return {
    pending,
    submit,
  }
}
